import { render, staticRenderFns } from "./CreatePuzzleModal.vue?vue&type=template&id=2f7ca24f"
import script from "./CreatePuzzleModal.vue?vue&type=script&lang=ts"
export * from "./CreatePuzzleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports